module.exports = __webpack_public_path__ + "img/connections_liveL.3fd8e864.png";